import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setConfigLoaded } from '../redux/appreadouts/actions';
import { FullScreenLoader } from '../components/Loader/FullScreenLoader';
import { defaultConfig } from '../config/default.config';

export const ConfigContext = React.createContext<typeof defaultConfig>(defaultConfig);

/**
 * Provides the App configuration to all consumers
 * @returns
 */
export const ConfigProvider: React.FC = ({ children }): JSX.Element => {
    const dispatch = useDispatch();
    const [state, setState] = useState({
        defaultConfig: undefined,
        isLoading: true,
    });

    useEffect(() => {
        setState({ isLoading: false, defaultConfig });
        dispatch(setConfigLoaded(true));
    }, [dispatch]);

    if (state.isLoading) {
        return <FullScreenLoader />;
    }

    return <ConfigContext.Provider value={state.defaultConfig}>{children}</ConfigContext.Provider>;
};
